import Icon from "@mui/material/Icon";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types"; // Add this import at the top

// Function to count different types of credentials from stealer results
function getCredentialCounts(stealer, customers) {
  // Initialize the counts
  let compromisedUsers = 0;
  let compromisedEmployees = 0;
  let thirdPartyCredentials = 0;

  // new count function
  if (stealer.isCombolist) {
    // check if usernames includes the domain of the customer
    if (stealer.username && stealer.username.includes("@")) {
      const domainInEmail = stealer.username.split("@")[1];
      if (
        domainInEmail &&
        ((customers &&
          customers.length > 0 &&
          customers.some((el) => {
            if (el.usernames && el.usernames.length > 0 && el.usernames.includes(domainInEmail)) {
              return true;
            }
            return false;
          })) ||
          (customers &&
            customers.length > 0 &&
            customers.some((el) => {
              if (el.usernames && el.usernames.length > 0 && el.usernames.includes(domainInEmail)) {
                return true;
              }
              return false;
            })))
      ) {
        compromisedEmployees += 1;
      } else {
        compromisedUsers += 1;
      }
    } else {
      compromisedUsers += 1;
    }
  } else {
    if (stealer.passwords && stealer.passwords.length > 0) {
      stealer.passwords.forEach((pw) => {
        // control username to count as employee
        if (
          pw.username &&
          customers &&
          customers.length > 0 &&
          customers.some((el) => {
            if (
              el.usernames &&
              el.usernames.length > 0 &&
              (el.usernames.some((user) => {
                if (
                  user.toLowerCase() === pw.username.toLowerCase() ||
                  pw.username.toLowerCase().endsWith("." + user.toLowerCase()) ||
                  pw.username.toLowerCase().endsWith("@" + user.toLowerCase())
                ) {
                  return true;
                }
                return false;
              }) ||
                el.passwords.some((user) => {
                  if (
                    user.toLowerCase() === pw.username.toLowerCase() ||
                    pw.username.toLowerCase().endsWith("." + user.toLowerCase()) ||
                    pw.username.toLowerCase().endsWith("@" + user.toLowerCase())
                  ) {
                    return true;
                  }
                  return false;
                }))
            ) {
              return true;
            }
          })
        ) {
          compromisedEmployees += 1;
        } else if (
          pw.URL &&
          customers &&
          customers.length > 0 &&
          customers.some((el) => {
            if (
              el.passwords &&
              el.passwords.length > 0 &&
              el.passwords.some((user) => {
                if (
                  pw.URL.toLowerCase() === user.toLowerCase() ||
                  pw.URL.toLowerCase().endsWith("." + user.toLowerCase())
                ) {
                  return true;
                }
                return false;
              })
            ) {
              return true;
            }
          })
        ) {
          // controllo customer
          compromisedUsers += 1;
        } else {
          thirdPartyCredentials += 1;
        }
      });
    }
  }

  return { compromisedUsers, compromisedEmployees, thirdPartyCredentials };
}

function CredentialStatistics({ stealer, customers }) {
  const { t } = useTranslation();
  const counts = getCredentialCounts(stealer, customers);

  if (!counts.compromisedEmployees && !counts.compromisedUsers && !counts.thirdPartyCredentials) {
    return null;
  }

  return (
    <div
      className="credential-statistics-container"
      style={{
        marginTop: "30px",
        marginBottom: "30px",
        backgroundColor: "#f0f8ff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <h3 style={{ marginBottom: "20px", textAlign: "center" }}>
        {t("stealers.credentials_summary")}
      </h3>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Compromised Users */}
        <div
          style={{
            textAlign: "center",
            padding: "15px",
            minWidth: "150px",
          }}
        >
          <div
            style={{
              width: "70px",
              height: "70px",
              background: "#4169E1",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 10px",
            }}
          >
            <Icon fontSize="large" style={{ color: "white" }}>
              people
            </Icon>
          </div>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4169E1",
            }}
          >
            {counts.compromisedUsers}
          </div>
          <div>{t("stealers.compromised_users")}</div>
        </div>

        {/* Compromised Employees */}
        <div
          style={{
            textAlign: "center",
            padding: "15px",
            minWidth: "150px",
          }}
        >
          <div
            style={{
              width: "70px",
              height: "70px",
              background: "#4169E1",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 10px",
            }}
          >
            <Icon fontSize="large" style={{ color: "white" }}>
              person
            </Icon>
          </div>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4169E1",
            }}
          >
            {counts.compromisedEmployees}
          </div>
          <div>{t("stealers.compromised_employees")}</div>
        </div>

        {/* Third Party Credentials */}
        <div
          style={{
            textAlign: "center",
            padding: "15px",
            minWidth: "150px",
          }}
        >
          <div
            style={{
              width: "70px",
              height: "70px",
              background: "#4169E1",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 10px",
            }}
          >
            <Icon fontSize="large" style={{ color: "white" }}>
              mediation
            </Icon>
          </div>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4169E1",
            }}
          >
            {counts.thirdPartyCredentials}
          </div>
          <div>{t("stealers.third_party_credentials")}</div>
        </div>
      </div>
    </div>
  );
}

CredentialStatistics.propTypes = {
  stealer: PropTypes.shape({
    results: PropTypes.array,
    passwords: PropTypes.array,
    creditcards: PropTypes.array,
  }),
  user: PropTypes.shape({
    id: PropTypes.string,
    clients: PropTypes.array,
    domains: PropTypes.array,
  }),
  customers: PropTypes.array,
};

CredentialStatistics.defaultProps = {
  stealer: {
    results: [],
    passwords: [],
    creditcards: [],
  },
  user: {
    id: "",
    clients: [],
    domains: [],
  },
  customers: [],
};

export default CredentialStatistics;
